import './bariPostAddToMdo/register';
import './bariPostCaroBodyWeightMeasurementsInactiveNotification/register';
import './bariPostCaroInactivityLifestyleCoachReport/register';
import './bariPostCaroInactivityPoliReport/register';
import './bariPostCaroInactivitySecretarialAssistantReport/register';
import './bariPostCaroQuestionnaireResponse/register';
import './bariPostCaroQuestionnaireResponsesInactiveNotification/register';
import './bariPostCaroWeightMeasurements/register';
import './bariPostDietConsultReport/register';
import './bariPostDietPlanAppointment/register';
import './bariPostDietitianReport/register';
import './bariPostEnrollment/register';
import './bariPostFollowUpWeightMeasurements/register';
import './bariPostLifestyleCoachReport/register';
import './bariPostMdoReport/register';
import './bariPostNurseSpecialistFollowUp/register';
import './bariPostNurseSpecialistReferral/register';
import './bariPostNurseSpecialistReport/register';
import './bariPostPoliReport/register';
import './bariPostPsychologistReport/register';
import './bariPostSecretarialAssistantFollowUp/register';
import './bariPostTreatmentReport/register';
